import React from "react";
import "./wallpaper.scss";
import background from "../../resources/background-photo.jpeg";
import { useAppSelector } from "../../hooks";

export interface WallpaperProps {
  children?: React.ReactNode;
}

export default function Wallpaper(props: WallpaperProps) {
  const { backgroundUrl } = useAppSelector(state => state.layouts);
  const { isLoggedIn } = useAppSelector(state => state.login);

  const style =
    backgroundUrl && isLoggedIn
      ? { backgroundImage: `url(${backgroundUrl})` }
      : { backgroundImage: `url(${background})` };

  return (
    <div className="background" style={style}>
      {props.children}
    </div>
  );
}
